module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume_pc/icon_lock-fea5d179d62991d7239b7ed9e0766610.png";